import React, { Component } from 'react';
import axios from 'axios';
import URLS from '../utils/urls';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TagsInput from '../components/TagsInput';

import Utils from '../utils/mci-utils';
import { emailQuote } from '../actions/policy';

class EmailQuoteForm extends Component{

    constructor(props){
        super(props);

        this.state = {
            message: '',
            receivers: [],
            sender: '',

            quote_info: JSON.parse(localStorage.getItem("mci_form"))
        };
    }

    componentDidMount(){
        const { insurer, premium } = this.props;

        this.setState({
            insurer: insurer.id,
            premium
        });
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            insurer: nextProps.insurer.insurer,
            premium: nextProps.premium
        });
    }

    handleTagsUpdate = (name, tags) => {
        this.setState({ [name]: tags });
    }

    onChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value
        });
    }

    sendEmail = (e) => {
        e.preventDefault();

        const { sender, receivers, message, insurer, premium, quote_info } = this.state;

        console.log(quote_info.selected_goods);

        const goods_cfr = Utils.sum(quote_info.selected_goods, "cfr");
        
        let email = {
            sender,
            receivers,
            message,
            insurer,
            premium: {
                premium_in_tshs: premium.premium,
                total_cfr_tshs: Math.round(parseFloat(goods_cfr) * quote_info.currency_rate.rate),
                total_sum_insured_tshs: Math.round(parseFloat(goods_cfr) * quote_info.currency_rate.rate)
            },
            currency: quote_info.currency_rate,
            goods: []
        };

        email.receivers.push(this.state.receiver);
        //TODO find a way of removing the undefined value in the receivers last index
        email.receivers.splice(-1, 1);

        quote_info.selected_goods.map( (good, index) => {
            return email.goods.push({
                name: good.section,
                cfr: parseFloat(good.cfr.replace(/[^\d\.\-]/g, "")) * quote_info.currency_rate.rate
            })
        })

        console.log(this.state);

        if(receivers.length > 0){
            axios.post(URLS.emailQuote, email)
                .then( (res) => {
                    this.setState({
                        success: true,
                        successMessage: res.data.success,
                    });
                })
                .catch( (err) => {
                    this.setState({
                        error: true,
                        errorMessage: "Email was not Sent. Please try again later"
                    });
                });
        }
        else{
            alert("Enter at least one sender and receiver email");
        }
    }

    render(){
        // console.log(this.state);

        const { success, successMessage, error, errorMessage } = this.state;

        return(
            <form onSubmit={ this.sendEmail }>
                <div className="messages">
                    { success ? 
                        <div className="alert alert-success" role="alert">
                            { successMessage }
                        </div>
                        :
                        null
                    }
                    { error ?
                        <div className="alert alert-danger" role="alert">
                            { errorMessage }
                        </div>
                        :
                        null
                    }
                </div>
                <div className="form-group">
                    <label>Sender's email</label>
                    <input type="email" className="form-control" onChange={this.onChange} name="sender" />
                </div>

                <div className="form-group">
                    <label>Receiver email(s)</label>
                    
                    <TagsInput 
                        name="receivers"
                        onTagsUpdate={ this.handleTagsUpdate } />
                    
                    <small className="text-muted">Multiple emails: Enter an email and press ENTER to add</small>
                </div>
                <div className="form-group">
                    <label>Message</label>
                    <textarea className="form-control" 
                        name="message" onChange={ this.onChange } rows="4" required ></textarea>
                </div>
                <button className="btn btn-success">
                    Send Quote
                </button>
                <button type="submit" className="btn btn-danger" data-dismiss="modal">
                    Cancel
                </button>
            </form>
        );
    }  
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({ emailQuote }, dispatch );
}

export default connect(null, mapDispatchToProps)(EmailQuoteForm);


// WEBPACK FOOTER //
// ./src/components/EmailQuoteForm.jsx